import { defineRoute } from "src/routing/defineRoute";
import { developmentRoute } from "src/routing/domains/developments/detail/developmentDetailPaths";

/**
 * Path + typed URL builder pairs for development plan-and-options routes.
 *
 * Kept separate from the route tree so `RouteUrls.ts` and pages can import paths without a cycle
 * through page `Component` imports.
 */
export const developmentPlanAndOptionsRoute = defineRoute(`${developmentRoute.path}/plan-and-options`);
export const developmentPlanDetailsRoute = defineRoute(`${developmentRoute.path}/plan-and-options/:readyPlanId`);
export const developmentPlanDataRoute = defineRoute(`${developmentRoute.path}/plan-and-options/:readyPlanId/planData`);
export const developmentOptionDataRoute = defineRoute(
  `${developmentRoute.path}/plan-and-options/:readyPlanId/optionData`,
);
export const developmentActivityRoute = defineRoute(`${developmentRoute.path}/plan-and-options/:readyPlanId/activity`);
export const developmentEditOptionsRoute = defineRoute(
  `${developmentRoute.path}/plan-and-options/:readyPlanId/edit-options`,
);
